import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Modules */
import { HojeadorModule } from './hojeador';
import { TablaModule } from './tabla';
import { AccionesModule } from './acciones';
import { AutocompleteModule } from './autocomplete';
import { SelectormesModule } from './selectormes';
import { FechaModule } from './fecha';
import { ABMTableModule } from './abmtable';
import { InputBSModule } from './inputbs';
import { FormularioModule } from './formulario';
import { GrillaModule } from './grilla';
import { ConfirmDialogModule } from './confirm-dialog';
import { Tabla2abmModule } from './tabla2abm';
import { HttpService } from './http.service';
import { ComponentesService } from './componentes.service';
import { BuscaChipsModule } from './busca-chips/busca-chips.module';
import { FileUploadModule } from './file-upload/file-upload.module';
import { MenuModule } from './menu/menu.module';
import { EditorModule } from './editor/editor.module';
import { FocusService } from './focus.service';
// import { UtilsModule } from '@tres-erres/ngx-utils';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		HojeadorModule,
		TablaModule,
		AccionesModule,
		InputBSModule,
		AutocompleteModule,
		SelectormesModule,
		FechaModule,
		ABMTableModule,
		FormularioModule,
		GrillaModule,
		ConfirmDialogModule,
		Tabla2abmModule,
		BuscaChipsModule,
		MenuModule,
		EditorModule,
		FileUploadModule
		// UtilsModule
	],
	exports: [
		HojeadorModule,
		TablaModule,
		AccionesModule,
		InputBSModule,
		AutocompleteModule,
		SelectormesModule,
		FechaModule,
		ABMTableModule,
		FormularioModule,
		GrillaModule,
		ConfirmDialogModule,
		Tabla2abmModule,
		BuscaChipsModule,
		MenuModule,
		EditorModule,
		FileUploadModule
		// UtilsModule
	],
	providers: [
		HttpService,
		ComponentesService,
		FocusService
	]
})
export class ComponentesModule { }
